import { useTheme } from '@mui/material'
import React from 'react'
import { colors } from '../../constants/colors'

/** Mailbox with a raised flag and a letter — empty notification tray state. */
const EmptyMailboxIllustration = ({ size = 64 }: { size?: number }) => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'
  const ink = isDark ? colors.WHITE : colors.BLACK_100
  const body = isDark ? colors.DARK_MODE_50 : colors.GEORGIAN_BAY_70
  const bodyShade = isDark ? colors.DARK_MODE_80 : colors.GEORGIAN_BAY_100
  const letter = isDark ? colors.DARK_MODE_10 : colors.WHITE

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* post */}
      <rect x="37" y="38" width="5" height="20" rx="1" fill={colors.RED_100} />
      {/* mailbox body */}
      <path
        d="M22 22h26a8 8 0 0 1 8 8v12H14V30a8 8 0 0 1 8-8Z"
        fill={body}
        stroke={ink}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {/* door */}
      <path
        d="M22 22a8 8 0 0 1 8 8v12H14V30a8 8 0 0 1 8-8Z"
        fill={bodyShade}
        stroke={ink}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {/* flag */}
      <path d="M44 32V12" stroke={ink} strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M44 12h8v6h-8"
        fill={colors.RED_100}
        stroke={ink}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {/* letter */}
      <g transform="rotate(-12 18 28)">
        <rect
          x="6"
          y="22"
          width="20"
          height="13"
          rx="1.5"
          fill={letter}
          stroke={ink}
          strokeWidth="1.5"
        />
        <path d="m6.5 23 9.5 7 9.5-7" stroke={ink} strokeWidth="1.5" strokeLinejoin="round" />
      </g>
      {/* sparkle lines */}
      <path d="M8 14l3 3M14 9l1 4M4 20l4 1" stroke={ink} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export default EmptyMailboxIllustration
